var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"mapbox-img",attrs:{"src":`https://api.mapbox.com/styles/v1/mapbox/light-v10/static/pin-l(${_vm.xCoord},${_vm.yCoord})/${_vm.xCoord},${_vm.yCoord},${_vm.zoom}/${_vm.width}x${_vm.height}?access_token=${_vm.accessToken}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }